import { Injectable } from "@angular/core";
import { JobDescription } from "src/app/ui/models/domains/pbm/Beneficiary/job-description";
import { AbstractParser } from "../../parser";
import { parseJobDescription } from "../beneficiary/beneficiary-parse-functions";

@Injectable()
export class JobDescriptionParser extends AbstractParser<JobDescription[]> {
  public parse(payload: any): JobDescription[] {
    return payload.map((item) => {
      return parseJobDescription(item);
    });
  }
}
